<ng-container *t="let t">
    <h3
        class="form-header"
        mat-dialog-title
        *ngIf="!data.id"
        i18n="@@60904ba396dadf48ca73398100d651e25bc9262c"
        t="60904ba396dadf48ca73398100d651e25bc9262c"
        >Add External Partner</h3
    >
    <h3
        class="form-header"
        mat-dialog-title
        *ngIf="data.id"
        i18n="@@5e5a4ef8f16ef22221ed82d163e5e900ca588fd1"
        t="5e5a4ef8f16ef22221ed82d163e5e900ca588fd1"
        >Update External Partner</h3
    >

    <div [formGroup]="externalForm" class="grid">
        <div fxLayout="row" fxLayoutGap="10px">
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@ed1341869cf9cb7017821057cb99854bb6ac9130"
                        t="ed1341869cf9cb7017821057cb99854bb6ac9130"
                        >Company name</tsl-label
                    >
                    <input tslInput required fullWidth maxlength="50" formControlName="company" />
                    <tsl-error *ngIf="company.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@766e4693c44e9da1d6735c0107534a42228ffc26"
                        t="766e4693c44e9da1d6735c0107534a42228ffc26"
                        >Service Type</tsl-label
                    >
                    <input
                        autocomplete="off"
                        tslInput
                        fullWidth
                        required
                        formControlName="servicetype"
                        [tslAutocomplete]="autoService"
                    />
                    <tsl-autocomplete
                        #autoService="tslAutocomplete"
                        (optionSelected)="onSelectServiceType($event.option)"
                    >
                        <tsl-option *ngFor="let item of serviceTypes" [value]="item.type">{{
                            translate.get(item.type)
                        }}</tsl-option>
                    </tsl-autocomplete>
                    <tsl-error *ngIf="servicetype.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@20d9489fdbfc121f7c504271b36691515d02f632"
                        t="20d9489fdbfc121f7c504271b36691515d02f632"
                        >Job Title</tsl-label
                    >
                    <input
                        autocomplete="off"
                        tslInput
                        fullWidth
                        required
                        formControlName="jobtitle"
                        [tslAutocomplete]="autoJobtitle"
                    />
                    <tsl-autocomplete
                        #autoJobtitle="tslAutocomplete"
                        (optionSelected)="onSelectJobTitle($event.option)"
                    >
                        <tsl-option *ngFor="let item of jobtitles" [value]="item.name">{{
                            translate.get(item.name)
                        }}</tsl-option>
                    </tsl-autocomplete>
                    <tsl-error *ngIf="jobtitle.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@9c3447608e3d32dbeb1ea759f8c5f5f936213b33"
                        t="9c3447608e3d32dbeb1ea759f8c5f5f936213b33"
                        >Department</tsl-label
                    >
                    <input
                        autocomplete="off"
                        tslInput
                        fullWidth
                        required
                        formControlName="department"
                        [tslAutocomplete]="autoDepartment"
                    />
                    <tsl-autocomplete
                        #autoDepartment="tslAutocomplete"
                        (optionSelected)="onSelectDepartment($event.option)"
                    >
                        <tsl-option *ngFor="let item of departments" [value]="item.name">{{
                            translate.get(item.name)
                        }}</tsl-option>
                    </tsl-autocomplete>
                    <tsl-error *ngIf="department.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label i18n="@@StreetAddressLine1" t="StreetAddressLine1"
                        >Street Address Line 1</tsl-label
                    >
                    <input tslInput required fullWidth maxlength="50" formControlName="address1" />
                    <tsl-error *ngIf="address1.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label i18n="@@StreetAddressLine2" t="StreetAddressLine2"
                        >Street Address Line 2</tsl-label
                    >
                    <input tslInput fullWidth maxlength="50" formControlName="address2" />
                    <tsl-error *ngIf="address2.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label i18n="@@City" t="City">City</tsl-label>
                    <input tslInput required fullWidth maxlength="30" formControlName="city" />
                    <tsl-error *ngIf="city.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@873b72903b1858a9cd6c8967521030b4d7d1435b"
                        t="873b72903b1858a9cd6c8967521030b4d7d1435b"
                        >State</tsl-label
                    >
                    <input tslInput fullWidth maxlength="30" formControlName="state" />
                    <tsl-error *ngIf="state.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@73f71f6be8e257467172f45a9e44934f979074e7"
                        t="73f71f6be8e257467172f45a9e44934f979074e7"
                        >Zip/Postal Code</tsl-label
                    >
                    <input type="number" tslInput fullWidth maxlength="10" formControlName="zipcode" />
                    <tsl-error *ngIf="zipcode.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div class="column" fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label i18n="@@Country" t="Country">Country</tsl-label>
                    <tsl-select required fullWidth formControlName="country">
                        <tsl-option *ngFor="let item of obCountries$ | async" [value]="item.countryID"
                            >{{ translate.get(item.name) }}
                        </tsl-option>
                    </tsl-select>
                    <tsl-error *ngIf="country.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <br />
    <div class="table-container">
        <table class="acreditations">
            <thead>
                <tr>
                    <th>
                        <label
                            class="label"
                            i18n="@@1bceea2a2b0db2ba2368ab532988ab5c1ef3b749"
                            t="1bceea2a2b0db2ba2368ab532988ab5c1ef3b749"
                            >What Certification?</label
                        >
                    </th>
                    <th>
                        <label
                            class="label"
                            i18n="@@600889f42ed29c7e8d6759417e8ec18b9a269f51"
                            t="600889f42ed29c7e8d6759417e8ec18b9a269f51"
                            >When Did You Get Certified?</label
                        >
                    </th>
                    <th>
                        <label
                            class="label"
                            i18n="@@5c6e62a783d740ae2d640d9c754f84d4f099b6ab"
                            t="5c6e62a783d740ae2d640d9c754f84d4f099b6ab"
                            >When Does The Certificate Expire?</label
                        >
                    </th>
                    <th>
                        <label
                            class="label"
                            i18n="@@59d00489a2079a4dd908b127a544d316b6f58a18"
                            t="59d00489a2079a4dd908b127a544d316b6f58a18"
                            >Who Certified It?</label
                        >
                    </th>
                    <th>
                        <label
                            class="label"
                            i18n="@@fdaace3b87747f2d7380af30f5d54ddc49680272"
                            t="fdaace3b87747f2d7380af30f5d54ddc49680272"
                            >Attachments</label
                        >
                    </th>
                    <th>
                        <button tsl-icon-button size="medium" (click)="onOpenCertification()">
                            <tsl-icon>add_circle</tsl-icon>
                        </button>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let acred of data.acreditations; let i = index">
                    <td>{{ getCertificationType(acred.certificationTypeId) }}</td>
                    <td>{{ acred.certifiedDate | date }}</td>
                    <td>{{ acred.expirationDate | date }}</td>
                    <td>{{ acred.certifierName }}</td>
                    <td>
                        <div class="file-list">
                            <ul>
                                <li *ngFor="let file of acred.attachments">
                                    <tsl-icon size="small" (click)="onDeleteExternalAttachment(acred, file)"
                                        >delete
                                    </tsl-icon>
                                    <a
                                        class="small"
                                        (click)="onDownloadExternalAttachment(file)"
                                        matTooltip="{{ file.name }}"
                                        >{{ file.name }}</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </td>
                    <td>
                        <!-- todo ttp -->
                        <button
                            tsl-icon-button
                            tooltip="Edit" i18n-tooltip="@@Edit" #editButton tslTooltip="{{ t('Edit', editButton) }}"
                            (click)="onEditCertification(acred, i)"
                        >
                            <tsl-icon>edit</tsl-icon>
                        </button>
                        <button tsl-icon-button (click)="onRemoveCertification(cert)">
                            <tsl-icon status="error">delete</tsl-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <br />
    <div class="right">
        <button tsl-button color="black" outline size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button
            tsl-button
            color="blue"
            filled
            size="small"
            [disabled]="externalForm.invalid"
            (click)="onSave()"
            i18n="@@Save"
            t="Save"
            >Save</button
        >
    </div>
</ng-container>
